import React, { useState, useEffect } from 'react'
import { Button, Input, Radio, Table, Tag ,Empty,ConfigProvider} from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import JW_GenPO from './JW_GenPO'
import EmptyData from '../Assets/EmptyData.jpg';

const { Search } = Input

const data = [
  {
    key: "01",
    sno: "01",
    month: "Mar Month",
    mspcname: "KARWAR",
    netorderqty: "1202.5 T",
    totalfgitem: "05",
    pogeneratedqty: "0",
    status: "Not Iniated",
  },
  {
    key: "02",
    sno: "02",
    month: "Mar Month",
    mspcname: "A1B2C3D",
    netorderqty: "1202.5 T",
    totalfgitem: "03",
    pogeneratedqty: "0",
    status: "Not Iniated",
  },
  {
    key: "03",
    sno: "03",
    month: "Mar Month",
    mspcname: "A1B2C3D",
    netorderqty: "1202.5 T",
    totalfgitem: "01",
    pogeneratedqty: "0",
    status: "completed",
  },
  {
    key: "04",
    sno: "04",
    month: "March",
    mspcname: "KARWAR",
    netorderqty: "1202.5 T",
    totalfgitem: "05",
    pogeneratedqty: "0",
    status: "completed",
  }
]

const JW_PO = () => {
  const [searchValue, setSearchValue] = useState("")
  const [filter, setFilter] = useState("all")
  const [filteredData, setFilteredData] = useState(data)
  const navigate = useNavigate();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const columns = [
    { title: "S.NO", dataIndex: "sno", key: "sno" },
    { title: "Month", dataIndex: "month", key: "month" },
    { title: "MSPC Name", dataIndex: "mspcname", key: "mspcname" },
    { title: "Net Order Qty", dataIndex: "netorderqty", key: "netorderqty" },
    { title: "Total FG Item", dataIndex: "totalfgitem", key: "totalfgitem" },
    { title: "PO Generated Qty", dataIndex: "pogeneratedqty", key: "pogeneratedqty" },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <Tag style={{ border: "1px", fontWeight: "400" }}>{status}</Tag>
      )
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (text, record) =>
        record.status === "completed"
          ? (
            <Button size='small' style={{ backgroundColor: "#BCB7B7", color: "#063253", borderRadius: "73.45px" }}>
              View
            </Button>
          )
          : (
            <Button
              size="small"
              style={{ backgroundColor: "#A7CCF2", color: "#063253", borderRadius: "73.45px" }}
              onClick={() => navigate("/jobwork/jobwork_po/jw_genpo")}
            >
              Gen PO
            </Button>
          )
    }
  ]

  // 🔹 Filter on searchValue change
  useEffect(() => {
    if (searchValue) {
      const filtered = data.filter(d =>
        d.mspcname.toLowerCase().includes(searchValue.toLowerCase())
      )
      setFilteredData(filtered)
    } else {
      setFilteredData(data)
    }
  }, [searchValue])

  const rowSelection = {
    selectedRowKeys,
    onChange: (newSelectedRowKeys) => {
      setSelectedRowKeys(newSelectedRowKeys);
    },
  };

  return (
    <div>
      <div style={{ marginBottom: 16, display: 'flex', padding: "20px", justifyContent: "flex-start", alignItems: 'center', gap: 95 }}>
        <Search
          placeholder="Search by MSPC"
          prefix={<SearchOutlined />}
          allowClear
          value={searchValue}
          onChange={e => setSearchValue(e.target.value)} // 🔹 live filtering
          style={{ width: 500 }}
        />
        <Radio.Group value={filter} style={{ alignSelf: "center" }} onChange={e => setFilter(e.target.value)}>
          <Radio.Button value="all" style={{borderRadius:"100px"}}>All</Radio.Button>
        </Radio.Group>
      </div>
      <ConfigProvider
              renderEmpty={() => (
                <Empty
                  image={EmptyData}
                  description="No CategoryMaster Data Available"
                  imageStyle={{ height: 200 }}
                />
              )}
            >
      <Table
        rowSelection={rowSelection}
        columns={columns}
        dataSource={filteredData}
        size="small"
        bordered
      />
      </ConfigProvider>
    </div>
  )
}
export default JW_PO
